import { z } from "zod";
import { defineWidget } from "@/lib/home/widget";

/** Saved prompts as buttons: one click starts a chat with it. */
export default defineWidget({
  type: "kourai.prompts",
  version: 1,
  title: "Prompts",
  description: "Prompts you reuse, one click each",
  sizes: ["s", "m", "l", "w", "xl"],
  defaultSize: "m",
  surfaces: ["newtab", "sidepanel"],
  data: "member",
  permissions: [],
  config: z.object({}),
  load: () => import("./prompts-widget"),
});
